import { CartUpdateEvent } from '@theme/events';

// Bridges Rebuy Smart Cart events into the theme's `cart:update` event
const REBUY_EVENTS = [
  'rebuy:cart.change',
  'rebuy:cart.update',
  'rebuy:cart.remove',
  'rebuy:cart.add',
];

const cartUrl = `${window.Shopify?.routes?.root ?? '/'}cart.js`;

const resolveCart = async (event) => {
  const detail = event?.detail;
  const candidate = detail?.cart ?? detail;
  if (candidate && typeof candidate.item_count === 'number') return candidate;

  try {
    const response = await fetch(cartUrl, { headers: { Accept: 'application/json' } });
    if (!response.ok) return null;
    return await response.json();
  } catch (_) {
    return null;
  }
};

const handleRebuyEvent = async (event) => {
  const cart = await resolveCart(event);
  if (!cart) return;

  document.dispatchEvent(
    new CartUpdateEvent(cart, 'rebuy-smart-cart', {
      itemCount: cart.item_count ?? 0,
      source: 'rebuy-smart-cart',
    })
  );
};

for (const eventName of REBUY_EVENTS) {
  document.addEventListener(eventName, handleRebuyEvent);
}
